// components
import GridPageAbstract from '../GridPageAbstract';
import { EmptyWalletTransparentBulkIcon } from '../../icons-lib/bulkIcons';
import config from '../../config';
import { MenuItem } from '@mui/material';
import i18 from '../../i18';
import AssignPayoutAccountDialog from '../dialogs/AssignPayoutAccountDialog';
import { ArrangeSquare2LinearIcon } from '../../icons-lib';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

export default class WalletsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'wallets';
        this.Server = this.props.context.getState().server.wallets;

        this.headerStartIcon = EmptyWalletTransparentBulkIcon;
        this.bannerImage = config?.bannerImages?.wallets || '';

        this.permissionName = 'approve-wallet';

        this.showHistoryFilters = true;
        // history fields - wallerHistory.status, walletHistory.dateFrom, walletHistory.dateTo
        // status: active, disabled, pending_verification

        this.historyFieldLabels = {
            parentLabel: 'walletHistory',
            statusLabel: 'status',
            dateFromLabel: 'dateFrom',
            dateToLabel: 'dateTo'
        };

        this.searchFields = [
            'walletNumber',
            'user.email',
            'merchant.name',
            'merchant.email',
            'location.name'
        ];

        this.exportButton = true;

        this.hiddenColumns = config?.hiddenColumns?.wallets || [];

        this.Head = [
            {
                id: 'walletNumber',
                label: 'walletNumber',
                alignRight: false,
                cell: 'Details',
                readOnly: true,
                hideOnAdd: true,
                primary: 'walletNumber',
                secondary: 'currentBalance',
                from: 'merchants'
            },
            {
                id: 'user.email',
                label: 'owner',
                type: 'owner',
                alignRight: false,
                ifNull: "enjoyEmail",
                cell: 'Associated',
                associatedSettings: { primary: 'email' },
                display: 'email',
                object: 'user'
                // nested: 'location.merchant',
                // fallbackNested: 'location',
                // kind: true,
                // from: 'users'
            },
            {
                id: 'user.enjoyEmail',
                label: 'enjoyEmail',
                alignRight: false,
                cell: 'Text',
                object: 'user',
                display: 'enjoyEmail',
                disableEditor: true
            },
            {
                id: 'location',
                label: 'location',
                alignRight: false,
                cell: 'Details',
                object: 'location',
                display: 'name',
                readOnly: true,
                hideOnAdd: true,
                from: 'merchantLocations',
                primary: 'name',
                secondary: 'merchant.email'
            },
            {
                id: 'payoutDetails',
                label: 'payoutDetails',
                alignRight: false,
                cell: 'Boolean',
                object: 'payoutAccount',
                // requiredFields: ['beneficiaryName', 'beneficiaryIban', 'name'],
                trueLabel: 'yes',
                falseLabel: 'no',
                disableEditor: true,
                filterCell: 'Existence',
                filterField: 'payoutAccount'
            },
            {
                id: 'payoutAccountsId',
                sortField: 'payoutAccount.name',
                label: 'payoutAccount',
                alignRight: false,
                cell: 'Select',
                from: 'payoutAccounts',
                display: 'name',
                fallbackDisplay: 'beneficiaryName',
                object: 'payoutAccount'
            },
            {
                id: 'payoutAccountAssignedDate',
                label: 'payoutAccountAssignedDate',
                alignRight: false,
                cell: 'Date',
                disableEditor: true,
                hideOnAdd: true
            },
            // {
            //     id: 'transactions',
            //     label: 'transactions',
            //     alignRight: false,
            //     cell: 'Text',
            //     disableEditor: true,
            //     hideOnAdd: true
            // },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Status',
                controller: 'wallets',
                fieldIdName: 'walletId',
                items: ['pending_verification', 'active', 'disabled'],
                filterBy: 'status',
                filterCell: 'Items',
                needTranslate: true,
                permissionName: 'approve-wallet'
            },

            {
                id: 'kind',
                label: 'category',
                alignRight: false,
                cell: 'ItemsLabel',
                items: ['user', 'merchant'],
                filterBy: 'kind',
                filterCell: 'Items',
                needTranslate: true
            },
            {
                id: 'merchantName',
                label: 'merchantName',
                alignRight: false,
                cell: 'Text',
                disableEditor: true,
                object: 'merchant',
                display: 'name'
            },
            {
                id: 'merchantEmail',
                label: 'merchantEmail',
                alignRight: false,
                cell: 'Text',
                disableEditor: true,
                object: 'merchant',
                display: 'email'
            },
            {
                id: 'currentBalance',
                label: 'balance',
                alignRight: false,
                cell: 'Amount',
                filterCell: 'Range',
                readOnly: true,
                hideOnAdd: true
            },
            {
                id: 'coinId',
                label: 'coin',
                alignRight: false,
                cell: 'Select',
                from: 'coins',
                display: 'name',
                object: 'coin',
                hideOnAdd: true,
                filterCell: 'Context',
                filterBy: 'coins'
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                readOnly: true,
                hideOnAdd: true
            }
        ].filter((it) => !this.hiddenColumns.includes(it.id));
    }

    handleAssign(event) {
        this.setState({ openAssignDialog: true, open: false });
    }
    handleCloseAssignDialog() {
        this.setState({ openAssignDialog: false });
        this.handleCloseMenu();
    }
    handleSaveAssignDialog() {
        this.setState({ openAssignDialog: false });
        this.handleCloseMenu();
        this.retrieveData();
    }
    renderCustomMenuItems() {
        const needsApproval =
            this.List.find((item) => item.id === this.state.menuClickItemId)
                ?.status !== 'active';
        return [
            this.allowedAction('assign-payout-account') && (
                <MenuItem
                    key="assign"
                    onClick={(event) => this.handleAssign(event)}
                    // sx={{ color: 'success.main' }}
                >
                    <ArrangeSquare2LinearIcon sx={{ mr: 1 }} />
                    {i18.t('buttons.assignPayoutAccount')}
                </MenuItem>
            ),
            this.allowedAction(this.permissionName) && needsApproval && (
                <MenuItem
                    key="approve"
                    onClick={(event) => this.handleActivateDialogOpen(event)}
                    sx={{ color: 'success.main' }}
                >
                    <TaskAltIcon sx={{ mr: 1 }} />
                    {i18.t('buttons.verify')}
                </MenuItem>
            )
        ].filter(Boolean);
    }
    renderCustom() {
        const item = this.List.find(
            (it) => it.id === this.state.menuClickItemId
        );
        const payoutAccountId = item?.payoutAccount?.id || '';
        const walletNumber = item?.walletNumber || '';
        const payoutAccounts =
            this.props.context.getState().controllersData.payoutAccounts;
        if (!payoutAccounts) return null;
        return (
            <AssignPayoutAccountDialog
                dialogOpen={!!this.state.openAssignDialog}
                walletNumber={walletNumber}
                payoutAccountId={payoutAccountId}
                payoutAccounts={payoutAccounts}
                server={this.props.context.getState().server.wallets}
                onClose={() => this.handleCloseAssignDialog()}
                onSave={() => this.handleSaveAssignDialog()}
            />
        );
    }
    handleChangeStatus = async (status) => {
        const ids = this.state.menuClickItemId
            ? [this.state.menuClickItemId]
            : this.state.selected;
        const id = ids.length === 1 ? ids[0] : null;
        if (id) {
            await this.changeStatus({
                walletId: id,
                state: status
            });
        } else {
            await this.changeStatus({
                walletIds: ids,
                state: status
            });
        }
    };
}
